(() => {
  const cleanReviewFocus = () => {
    document
      .querySelectorAll('.jdgm-rev__rating[role="img"][tabindex]')
      .forEach((rating) => rating.removeAttribute('tabindex'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanReviewFocus, { once: true });
  } else {
    cleanReviewFocus();
  }

  const observer = new MutationObserver(cleanReviewFocus);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
